Ext.define('SA.PointsDatasetLimit', {
    constructor(data) {
        this.proposedUse = data.proposedUse;

        this.perExport = new SA.PointsLimitInterval(data.perExport);
        this.perWeek = new SA.PointsLimitInterval(data.perWeek);
        this.perYear = new SA.PointsLimitInterval(data.perYear);
    },

    isBeyondLimit() {
        return [this.perExport, this.perWeek, this.perYear].some(interval => interval.isBeyondLimit());
    },

    serialize() {
        var proposedUse = this.proposedUse,
            perExport = this.perExport.serialize(),
            perWeek = this.perWeek.serialize(),
            perYear = this.perYear.serialize();

        return {proposedUse, perExport, perWeek, perYear};
    }
});